import React from 'react';
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import { DeleteOutline, EditOutlined } from '@mui/icons-material';
import { CustomGroup } from '../../api/models/CustomGroup';
import { ProvisioningStatus } from '../../api/models/ProvisioningStatus';

interface CustomGroupsRowProps {
  group: CustomGroup;
  index: number;
  totalGroups: number;
  isLoading: boolean;
  onDeleteGroup: (groupName: string) => void;
  onEditGroup: (groupName: string) => void;
}

const CustomGroupsRow: React.FC<CustomGroupsRowProps> = ({
  group,
  index,
  totalGroups,
  isLoading,
  onDeleteGroup,
  onEditGroup,
}) => {
  const isPendingStatus = (status: string): boolean => {
    return status.toLowerCase() === ProvisioningStatus.PENDING;
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case ProvisioningStatus.PENDING:
        return 'warning';
      case ProvisioningStatus.ACTIVE:
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <>
      <ListItem>
        <ListItemText
          primary={
            <>
              <Typography variant="subtitle1" component="span" sx={{ marginRight: 1 }}>
                {group.groupName}
              </Typography>
              <Chip
                label={group.status}
                size="small"
                color={getStatusColor(group.status) as any}
              />
            </>
          }
          secondary={
            <>
              <Typography variant="body2" color="text.secondary" component="span">
                Created by: {group.createdBy}
              </Typography>
              <br />
              <Typography variant="body2" color="text.secondary" component="span">
                Created on: {new Date(group.createdOn).toLocaleDateString()}
              </Typography>
            </>
          }
          primaryTypographyProps={{ component: 'div' }}
          secondaryTypographyProps={{ component: 'div' }}
        />
        <ListItemSecondaryAction>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              onClick={() => onEditGroup(group.groupName)}
              disabled={isLoading || isPendingStatus(group.status)}
              title={isPendingStatus(group.status) ? 'Cannot edit pending groups' : 'Edit group users'}
            >
              <EditOutlined />
            </IconButton>
            <IconButton
              edge="end"
              onClick={() => onDeleteGroup(group.groupName)}
              disabled={isLoading || isPendingStatus(group.status)}
              title={isPendingStatus(group.status) ? 'Cannot delete pending groups' : 'Delete group'}
            >
              <DeleteOutline />
            </IconButton>
          </Box>
        </ListItemSecondaryAction>
      </ListItem>
      {index < totalGroups - 1 && <Divider />}
    </>
  );
};

export default CustomGroupsRow;